import shop from "shop/shop"
import categoryStore from "stores/categoryStore"
import productStore from "stores/productStore"

function _buildLink( product ) {
  const catId = product.category && product.category.map_id
  if ( !catId ) return `/product/${product.map_id || product.article_id}/`

  // Walk up the category tree to build the numeric catpath (e.g. /49/46/134)
  const parts = []
  const visited = {}
  let id = catId
  while ( id ) {
    if ( visited[id] ) break
    visited[id] = true
    parts.unshift( id )
    const cat = categoryStore.categoriesById.get( id )
    id = cat && cat.parent
  }
  const catpath = '/' + parts.join( '/' )

  let segmentPath
  if ( shop.config.plugin && shop.config.plugin.SEOCategoryLink && categoryStore._SEOCategoryTree ) {
    const seoEntry = categoryStore._SEOCategoryTree[ catpath ]
    segmentPath = seoEntry ? seoEntry.textpath : catpath
  } else {
    segmentPath = catpath
  }

  const shortDes = product.desc && product.desc.short_des
    ? encodeURIComponent( product.desc.short_des )
    : ''
  return shortDes
    ? `/product${segmentPath}/${shortDes}/${product.map_id || product.article_id}/`
    : `/product${segmentPath}/${product.map_id || product.article_id}/`
}

export function buildProductLink( product ) {
  // Full product with category → build link directly
  if ( product.category && product.category.map_id ) {
    return _buildLink( product )
  }

  // No category: check productStore cache (keyed by map_id)
  const lookupId = product.map_id || product.article_id
  const cached = productStore.productById.get( lookupId )
  if ( cached && cached.category && cached.category.map_id ) {
    return _buildLink( cached )
  }

  // Fallback: simple ID-based URL
  return `/product/${lookupId}/`
}



// WEBPACK FOOTER //
// ./src/components/Product/productLink.js